// const requiredAttributes = [
//   'sku',
//   'name',
//   'option_text_brand',
//   'prices_with_tax',
//   'image',
//   '_media_',
//   'stock',
//   'label',
//   'product_fees',
//   'rewrite_url',
//   'attributes',
//   'short_description',
//   'product_attributes',
//   'eligible_for_tabby',
//   'eligible_for_tamara',
//   'product_fees',
//   'option_text_eligible_for_tabby',
//   'option_text_eligible_for_tamara',
//   'back_orders',
//   'show_discount_price',
//   'custom_related_products',
//   'brand_logo',
//   'reviews_count',
//   'option_text_color',
//   'flash_sale_end_date',
//   'flash_sale_start_date',
//   'has_options',
//   '_configurables',
//   'option_details',
//   'category',
//   'suggest',
//   'entity_id',
//   '_category_',
//   'option_text_brands',
//   'stock_innova',
//   'prescription_upload_required',
//   'innova_url',
//   'tier_prices',
// ];

const requiredAttributes = [
  'sku',
  'name',
  'prices_with_tax',
  'image',
  '_media_',
  'stock',
  'brand_logo',
  'entity_id',
  '_category_',
  'prescription_upload_required',
  'innova_url',
  'cart_rule',
  'labels',
  'brand_url',
  'brand_label',
  'image_url',
  'tier_prices',
  'option_text_offer_type',
  'type_id',
  'flash_sale_start_date',
  'flash_sale_end_date',
];

export const selectedAttributes = requiredAttributes
  ?.map((attr) => `select=${attr}`)
  ?.join('&');
